export enum SupabaseCodeError {
  UniquenessViolation = '23505'
}

type SupabaseLikeError = {
  message: string
  code?: string
  details?: string | null
  hint?: string | null
}

export function isSupabaseError(
  err: unknown
): err is SupabaseLikeError {
  return (
    typeof err === "object" &&
    err !== null &&
    "message" in err &&
    typeof (err as {message: string}).message === "string" &&
    "code" in err
  )
}
